<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">Wybierz zawodnika</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-select
          v-model="runner"
          label="Zawodnik"
          :items="options.runners">
        </v-select>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn :color="options.color + ' darken-1'" flat="flat" @click.native="agree">Kopiuj</v-btn>
        <v-btn color="grey" flat="flat" @click.native="cancel">Anuluj</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      runner: null,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        runners: [],
        color: 'primary',
        width: 400

      }
    }),

    methods: {
      open (options) {
        this.dialog = true
        this.options = Object.assign(this.options, options)

        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },

      agree () {
        this.resolve({value: this.runner})
        this.dialog = false
      },

      cancel () {
        this.resolve(false)
        this.dialog = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/plan/CopyWorkoutDialog.vue